import axios from "axios";

const BASE_URL = `/m-1/contact`;

/**
 * Serwis do komunikacji z API - endpoint /contact
 */
export const ContactService = {
    getProblemForForm,
    contactFormMailMessage
};

function getProblemForForm() {
    return axios.get(`${BASE_URL}/problems`);
}

function contactFormMailMessage(clientId, data) {
    return axios.post(`${BASE_URL}/send-mail/${clientId}`, data);
  }